import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scrollTop", "scrollContent", "dummy"]
  
  connect() {
    this.initializeHorizontalScroll()
    this.setupResizeListener()
  }

  initializeHorizontalScroll() {
    // Garantir que os elementos existem
    if (!this.hasScrollTopTarget || !this.hasScrollContentTarget || !this.hasDummyTarget) {
      return
    }

    // Configurar scroll horizontal
    this.updateDummyWidth()
    this.setupScrollSync()
  }

  updateDummyWidth() {
    const containerWidth = this.scrollContentTarget.parentElement.clientWidth
    const paddingTotal = 48 // px-6 = 24px cada lado
    const minCardWidth = 1150
    const minTotalWidth = minCardWidth + paddingTotal // 948px
    const scrollSpace = 24 // Respiro lateral
    
    if (containerWidth < minTotalWidth) {
      // Forçar os CARDS a terem largura maior que o container
      const targetScrollWidth = minTotalWidth + scrollSpace // 972px
      const cardWidth = minCardWidth + scrollSpace // 924px
      
      // Configurar o dummy
      this.dummyTarget.style.width = targetScrollWidth + 'px'
      this.dummyTarget.style.minWidth = targetScrollWidth + 'px'
      
      // FORÇAR os cards a serem maiores que o container disponível
      this.applyCardStyles(cardWidth)
      
      // Deixar o container com largura natural para criar scroll
      this.scrollContentTarget.style.minWidth = ''
      this.scrollContentTarget.style.width = ''
    } else {
      // Tela grande: restaurar comportamento normal
      this.dummyTarget.style.width = containerWidth + 'px'
      this.dummyTarget.style.minWidth = containerWidth + 'px'
      
      // Remover CSS forçado dos cards
      this.removeCardStyles()
      
      this.scrollContentTarget.style.minWidth = ''
      this.scrollContentTarget.style.width = ''
    }
  }

  applyCardStyles(cardWidth) {
    let style = document.getElementById('vehicles-card-style')
    if (!style) {
      style = document.createElement('style')
      style.id = 'vehicles-card-style'
      document.head.appendChild(style)
    }
    style.textContent = `
      .vehicles-list .vehicle-card {
        min-width: ${cardWidth}px !important;
        width: ${cardWidth}px !important;
        flex-shrink: 0 !important;
      }
    `
  }

  removeCardStyles() {
    const existingStyle = document.getElementById('vehicles-card-style')
    if (existingStyle) {
      existingStyle.remove()
    }
  }

  setupScrollSync() {
    // Evitar loops infinitos de sincronização
    let syncing = false
    
    this.scrollTopTarget.addEventListener('scroll', () => {
      if (!syncing) {
        syncing = true
        this.scrollContentTarget.scrollLeft = this.scrollTopTarget.scrollLeft
        syncing = false
      }
    })
    
    this.scrollContentTarget.addEventListener('scroll', () => {
      if (!syncing) {
        syncing = true
        this.scrollTopTarget.scrollLeft = this.scrollContentTarget.scrollLeft
        syncing = false
      }
    })
  }

  setupResizeListener() {
    // Debounce para performance no resize
    let resizeTimeout
    const debouncedUpdate = () => {
      clearTimeout(resizeTimeout)
      resizeTimeout = setTimeout(() => {
        this.updateDummyWidth()
      }, 100)
    }
    
    window.addEventListener('resize', debouncedUpdate)
    
    // Armazenar referência para cleanup
    this.resizeHandler = debouncedUpdate
  }

  disconnect() {
    // Cleanup
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler)
    }
    
    // Remover estilos aplicados
    this.removeCardStyles()
  }
}